/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import moment from 'moment';
import * as actionTypes from './actionTypes';

const serverTimezoneDate = (date) => {
  return moment(
    new Date(
      new Date(date).toLocaleString('en-US', {
        timeZone: process.env.REACT_APP_TIMEZONE,
      })
    )
  ).format('YYYY-MM-DD');
};

const initilaState = {
  selectedClient: 'PQM',
  invoiceNumber: '',
  rebateProgramCode: {},
  unfreezeInvoiceData: {
    defInvoiceSelectModeCd: '',
    rebateProgramCode: '',
    planType: '',
    forAllMfg: false,
    quarter: null,
    mfgIdList: null,
    // userId: localStorage.getItem('logInUser'),
    runProcedure: '',
    mailingDate: serverTimezoneDate(new Date()),
    invoiceNum: '',
  },
  errorMessages: [],
};

const reducer = (state = initilaState, action) => {
  switch (action.type) {
    case 'SET_SELECTED_CLIENT': {
      return { ...state, selectedClient: action.payload };
    }
    case 'SET_INVOICE_NUMBER': {
      return { ...state, invoiceNumber: action.payload };
    }
    case actionTypes.GET_ALL_REBATE_PROGRAMS: {
      return { ...state, rebateProgramCode: action.payload };
    }
    case actionTypes.SET_REQ_RECORD_MAILING_DATA: {
      return { ...state, unfreezeInvoiceData: action.payload };
    }
    case actionTypes.GET_MANUFACTURERS_BY_PQR: {
      return { ...state, manufacturersByPQR: action.payload };
    }
    case actionTypes.UNFREEZE_INVOICE: {
      return { ...state, unfreezeInvoiceResponseData: action.payload };
    }
    case actionTypes.SET_DEFAULT_QTR: {
      return { ...state, defaultQtrUnfreezeInv: action.defaultQtrUnfreezeInv };
    }
    case actionTypes.SET_ERROR_MESSAES: {
      return { ...state, errorMessages: action.payload };
    }
    case actionTypes.RESET_UNFREEZE_INVOICE_STORE: {
      return { ...initilaState };
    }

    default:
      return state;
  }
};

export default reducer;
